const FILE_NAME_PATTERN = /^[A-Za-z0-9]+([_-][A-Za-z0-9]+)*(\.[A-Za-z0-9]+)*$/;

export const isValidFileName = (name) => {
  if (!name) return false;
  return FILE_NAME_PATTERN.test(name);
};

export const fileNameError = (name) =>
  `Invalid file name "${name}". Use letters/numbers only, with "-" or "_" as separators (no spaces or special characters).`;
